import { render, staticRenderFns } from "./view20.vue?vue&type=template&id=20e480c3&scoped=true"
import script from "./view20.vue?vue&type=script&lang=js"
export * from "./view20.vue?vue&type=script&lang=js"
import style0 from "./view20.vue?vue&type=style&index=0&id=20e480c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e480c3",
  null
  
)

export default component.exports